import React from 'react';

/**
 * Le socle commun aux deux pages légales (mentions et confidentialité).
 *
 * UNE SEULE DATE pour les deux : elles se lisent ensemble, et deux dates différentes en tête de page
 * font douter de celle qui fait foi. On la bouge à chaque modification de fond, jamais pour une
 * correction de typographie.
 */
export const LEGAL_LAST_UPDATED = '18 septembre 2026';

/** Titre de section — un seul endroit pour la couleur, prise dans les jetons et non écrite en dur. */
export const LegalSection = ({ titre, children }: { titre: string; children: React.ReactNode }) => (
    <section className="space-y-2">
        <h2 className="text-sm font-semibold text-brand-600">{titre}</h2>
        {children}
    </section>
);

/** Paragraphe courant. Le corps des pages légales est dense : une seule taille, un seul interligne. */
export const P = ({ children }: { children: React.ReactNode }) => (
    <p className="text-xs text-content-muted leading-relaxed text-pretty">{children}</p>
);

export const UL = ({ children }: { children: React.ReactNode }) => (
    <ul className="list-disc pl-5 text-xs text-content-muted space-y-1.5 leading-relaxed">{children}</ul>
);

export const MailLien = ({ adresse }: { adresse: string }) => (
    <a href={`mailto:${adresse}`} className="text-content hover:text-brand-600 transition-colors">{adresse}</a>
);

/**
 * En-tête commun : la date, et le lien vers l'autre page.
 *
 * Les deux pages ne se renvoyaient pas l'une à l'autre : depuis les mentions légales, il fallait
 * revenir à l'accueil puis retrouver le lien de la politique de confidentialité en pied de page.
 */
export const LegalEnTete = ({ titre, autreLien, autreLabel }: { titre: string; autreLien: string; autreLabel: string }) => (
    <div className="space-y-3">
        <div className="flex items-baseline justify-between gap-3 flex-wrap">
            <h1 className="text-lg font-bold text-content tracking-tight">{titre}</h1>
            <a href={autreLien} className="text-[11px] font-semibold text-content-muted hover:text-brand-600 transition-colors">
                {autreLabel} →
            </a>
        </div>
        <p className="text-[10px] text-content-muted italic">Dernière mise à jour : {LEGAL_LAST_UPDATED}</p>
    </div>
);
